export class ParametroFilter {
  tipo?: string;
  texto?: string;
}
